import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  updateUserPreferences,
  type UserPreferences,
  type UserProfile,
} from "../api/userService";
import { useAxiosInstance } from "./useAxiosInstance";

export const useUpdatePreferences = () => {
  const axiosInstance = useAxiosInstance();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: UserPreferences) =>
      updateUserPreferences(axiosInstance, payload),
    onSuccess: (_, payload) => {
      queryClient.setQueryData<UserProfile>(["user"], (user) =>
        user ? { ...user, ...payload } : user,
      );
    },
  });
};
